import { Card, Col, Row } from 'antd';
import { Meta } from 'antd/lib/list/Item';
import { AuthContext } from 'context/auth';
import airTreeImage from 'images/airtree.jpg';
import forestViewImage from 'images/forestview.jpg';
import 'ol/ol.css';
import { useContext } from 'react';
import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();
  const { appDomain } = useContext(AuthContext);

  return (
    <Row justify="space-around" align="middle" gutter={16}>
      {
        appDomain === 'ForestView' &&
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Card
            onClick={() => navigate("/forestview", { replace: true })}
            style={{ marginBottom: '20px' }}
            hoverable
            cover={<img alt="example" src={forestViewImage} />}
          >
            <Meta style={{ minHeight: '100px' }} title="ForestView" description="Consentirà all’utente di visualizzare la copertura verde di un’area disegnata su mappa con i relativi dati statistici associati e di conseguenza costituire un efficace supporto alle decisioni per la silvicoltura" />
          </Card>
        </Col>
      }

      {
        appDomain === 'AirTree' &&
        <Col xs={24} sm={24} md={24} lg={12} xl={12}>
          <Card
            onClick={() => navigate("/airtree-list", { replace: true })}
            style={{ marginBottom: '20px' }}
            hoverable
            cover={<img alt="example" src={airTreeImage} />}
          >
            <Meta style={{ minHeight: '100px' }} title="AirTree" description="Strumento di progettazione aree verdi con specifica vegetazione per il calcolo della capacità di rimozione degli inquinanti atmosferici." />
          </Card>
        </Col>
      }


    </Row>
  );
}

export default Home;

